import type {AnyExtension} from "@tiptap/core";
import type {PluginKey} from "@tiptap/pm/state";
import type {VariableCatalogue} from "../model/types";
import {createVariableCatalogueStore} from "./variableCatalogueStore";
import {VariableNode} from "./VariableNode";
import {VariableSuggestion} from "./VariableSuggestion";

export interface VariableExtensionOptions {
    /** Ghost text after the `/` while nothing has been typed yet; the document is the search field. */
    hint?: string;
    /** The popup's search header. Off where the document already shows what was typed. */
    search?: boolean;
    /** Names the suggestion's plugin, for a host that asks `isVariablePickerOpen` with its own key. */
    pluginKey?: PluginKey;
}

/**
 * Variables for one editor: one catalogue store, read by the node, the suggestion and the chips
 * alike, so `setVariableCatalogue` swaps it for all of them. The preview is only what examples
 * resolve against, never what a reader will be shown.
 */
export const variableExtensions = (
    catalogue: VariableCatalogue,
    options: VariableExtensionOptions = {},
): AnyExtension[] => {
    const store = createVariableCatalogueStore(catalogue);

    return [VariableNode.configure({store}), VariableSuggestion.configure({store, ...options})];
};

export default variableExtensions;
